"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageChoiceButtons = void 0;
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const ImageButton_1 = require("./ImageButton");
const animations_1 = require("../../animations");
const framer_motion_1 = require("framer-motion");
const ImageChoiceButtons = ({ choices, imageNames, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
className, gameplayStyle, highlightedChoices, disabled, onInteract, identifiersForAnimation, onAnimationComplete, }) => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [imageHeight, setImageHeight] = (0, react_1.useState)('225px');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [imageWidth, setImageWidth] = (0, react_1.useState)('225px');
    const [allImagesLoaded, setAllImagesLoaded] = (0, react_1.useState)(false);
    // animation controls
    const controls = (_a = imageNames === null || imageNames === void 0 ? void 0 : imageNames.map(() => (0, framer_motion_1.useAnimation)())) !== null && _a !== void 0 ? _a : [];
    (0, react_1.useEffect)(() => {
        async function startAnimations() {
            if (!identifiersForAnimation || !onAnimationComplete) {
                return;
            }
            if (!identifiersForAnimation.some(id => {
                return imageNames.includes(id);
            })) {
                onAnimationComplete(identifiersForAnimation);
                return;
            }
            if (imageNames.length !== controls.length) {
                onAnimationComplete(identifiersForAnimation);
                return;
            }
            await Promise.all(identifiersForAnimation.map(id => {
                const indexInImageNames = imageNames.findIndex(name => name === id);
                if (indexInImageNames > -1) {
                    return controls[indexInImageNames].start(animations_1.shakeAnimation);
                }
                return;
            }));
            onAnimationComplete(identifiersForAnimation);
        }
        startAnimations();
    }, [identifiersForAnimation, controls, onAnimationComplete]);
    (0, react_1.useEffect)(() => {
        async function loadAll() {
            const promises = choices.map(src => {
                return new Promise(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = () => resolve();
                    img.onerror = () => resolve();
                });
            });
            return Promise.all(promises).then(() => {
                console.log('done loading images');
            });
        }
        loadAll().then(() => setAllImagesLoaded(true));
    }, [choices]);
    return (react_1.default.createElement(material_1.Grid, { container: true, columnGap: { xs: 3, sm: 3, md: 6 }, justifyContent: "center", maxHeight: '600px', minHeight: '100px', minWidth: 0, sx: { aspectRatio: '1/1', height: '100%', width: 'auto' } }, !allImagesLoaded ? (react_1.default.createElement("div", { style: { marginTop: '25%' } },
        react_1.default.createElement(material_1.CircularProgress, { sx: { color: 'red' } }))) : (choices.map((image, index) => {
        return (react_1.default.createElement(material_1.Grid, { item: true, key: image, xs: 5, sm: 5, md: 5, justifyContent: 'center', container: true, borderRadius: '1rem', minWidth: 0, minHeight: 0, position: 'relative' },
            react_1.default.createElement(framer_motion_1.motion.div, { key: imageNames[index], animate: controls[index], style: {
                    maxHeight: '100%',
                    minWidth: '0%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                react_1.default.createElement(ImageButton_1.ImageButton, { src: image, imageName: imageNames[index], onInteract: onInteract, disabled: disabled, maxHeight: imageHeight, maxWidth: imageWidth, gameplayStyle: gameplayStyle, className: className, highlighted: highlightedChoices.includes(imageNames[index]), blurred: highlightedChoices.length > 0 &&
                        !highlightedChoices.includes(imageNames[index]) }))));
    }))));
};
exports.ImageChoiceButtons = ImageChoiceButtons;
